var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.39857 15.4352C8.79309 14.8441 7.79135 14.8204 7.15733 15.3863C6.5249 15.9507 6.49954 16.8884 7.10503 17.481L11.8596 22.2074C12.1576 22.4993 12.5697 22.6652 13.0008 22.6667H13.0072C13.4367 22.6667 13.8472 22.5037 14.1452 22.2148L24.887 11.8451C25.4956 11.257 25.4798 10.3192 24.8505 9.75038C24.2197 9.18004 23.2163 9.19782 22.6093 9.78445L13.0151 19.0476L9.39857 15.4352Z","fill":"currentColor"}));
}

Check.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Check;

Check.default = Check;
